import script from "./OperatorApplicationDialogs.vue?vue&type=script&lang=ts&setup=true"
export * from "./OperatorApplicationDialogs.vue?vue&type=script&lang=ts&setup=true"

import "./OperatorApplicationDialogs.vue?vue&type=style&index=0&id=74051c72&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-74051c72"]])

export default __exports__